module.exports = __webpack_public_path__ + "img/product.bace93a0.svg";